import { RIAS2ParsedResult } from "@api/assessments/assessment-schema-types";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

export const RIAS_2_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: RIAS2ParsedResult,
  sections: [
    // --- PDF demographics ---
    {
      type: "key_value_list",
      label: "Interpretive Report",
      source: "sections.Interpretive Report",
      editable: false,
    },

    // --- XLSX demographics ---
    {
      type: "key_value_list",
      label: "Test Info",
      source: "sections.Test Info",
    },
    {
      type: "key_value_list",
      label: "Base Information",
      source: "sections.Base information",
    },
    {
      type: "key_value_list",
      label: "Additional Information",
      source: "sections.Additional Information (Optional)",
    },
    {
      type: "key_value_list",
      label: "Score Summary",
      source: "sections.Score summary",
      editable: true,
    },

    // --- Score tables (PDF) ---
    {
      type: "dynamic_score_tables",
      label: "Subtest Scores / Index Summary",
      source: "sections.Subtest Scores/Index Summary",
      tableNameKey: "Table Name",
      headersKey: "Column Headers",
      rowsKey: "Rows",
      editable: true,
    },
    {
      type: "dynamic_score_tables",
      label: "Extended Score Summary",
      source: "sections.RIAS-2 Extended Score Summary Table",
      tableNameKey: "Table Name",
      headersKey: "Column Headers",
      rowsKey: "Rows",
      editable: true,
    },
    {
      type: "dynamic_score_tables",
      label: "Discrepancy Score Summary",
      source: "sections.RIAS-2 Discrepancy Score Summary Table",
      tableNameKey: "Table Name",
      headersKey: "Column Headers",
      rowsKey: "Rows",
      editable: true,
    },

    // --- Graph data (PDF) ---
    {
      type: "score_table",
      label: "RIAS-2 Profiles",
      source: "sections.RIAS-2 Profiles",
      columns: [
        { key: "Graph Name", label: "Graph", editable: false },
        { key: "Series", label: "Series", editable: false },
        { key: "Label", label: "Label", editable: false },
        { key: "Value", label: "Value", editable: true },
      ],
    },
    {
      type: "score_table",
      label: "Total Battery Profiles",
      source: "sections.RIAS-2 Total Battery Profiles",
      columns: [
        { key: "Graph Name", label: "Graph", editable: false },
        { key: "Series", label: "Series", editable: false },
        { key: "Label", label: "Label", editable: false },
        { key: "Value", label: "Value", editable: true },
      ],
    },

    // --- Other Notes ---
    {
      type: "key_value_list",
      label: "Other Notes",
      source: "sections.Other Notes",
      editable: false,
    },

    // --- Index T-Score Summary (primary output table) ---
    {
      type: "score_table",
      label: "Index T-Score Summary",
      source: "index_tscore.data",
      columns: [
        { key: "Composite", label: "Composite", editable: false },
        {
          key: "Standard Score",
          label: "Standard Score",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "Percentile Rank",
          label: "Percentile Rank",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "95 % Confidence Interval",
          label: "95% Confidence Interval",
          editable: true,
        },
      ],
    },
  ],
};
